import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeliveryCodes } from 'src/app/data/model/deliver-codes';
import { SuspendResumePrintApiService } from 'src/app/shared/api/services/suspend-resume-print.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-resume-print',
  standalone: false,
  //imports: [SharedModule],
  templateUrl: './resume-print.component.html',
  styleUrls: ['./resume-print.component.scss']
})
export class ResumePrintComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DeliveryCodes, private router: Router,
    private suspendresume: SuspendResumePrintApiService) { }

    suspend():void{
      this.suspendresume.suspend_resume(false).subscribe();
      let currentUrl = this.router.url;
      this.router.navigateByUrl('/currentUrl',{skipLocationChange:true}).then(()=>{
        this.router.navigate([currentUrl]).then(()=>{
        });
      });
    }

}
